import React from "react";
import { object, array, number, string } from "prop-types";
import { Link } from "@quintype/components";

import AuthorDefaultLogo from "../../atoms/author-default-img";

import "./story-card24.m.css";

const StoryCard24 = ({ story, headerLevel, headerType }) => {
  const name = story?.metadata?.["budget-author"];
  const budgetImage = story?.metadata?.["budget-image-url"];
  const budgetQuote = story?.metadata?.["budget-quote"];
  const budgetDesignation = story?.metadata?.["budget-designation"];

  return (
    <div className="story-card story-card-24" styleName="story-card-24" id="story-card-24">
      <Link href={`/${story.slug}`}>
        <div styleName="author-wrapper">
          <div styleName="author-image">
            {budgetImage ? (
              <img src={budgetImage} alt={name} width={80} height={80} />
            ) : (
              <AuthorDefaultLogo width={80} height={80} />
            )}
          </div>
          <div styleName="auth-info">
            <span styleName="title">{name}</span>
            <span styleName="sub-title">{budgetDesignation}</span>
          </div>
        </div>

        <div styleName="card-content" className="card-content">
          <span styleName="summary" className="summary line-clamp-6">
            {budgetQuote}
          </span>
        </div>
      </Link>
    </div>
  );
};

StoryCard24.defaultProps = {
  aspectRatio: [1, 1],
  imageType: "image16x9",
  headerType: 11,
  headerLevel: 2
};

StoryCard24.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number
};

export default StoryCard24;
